import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useBrand } from "@/brand/BrandProvider";
import { tx } from "@/components/ui";

const initials = (name: string) => name.split(/\s+/).filter(Boolean).slice(0, 3).map((w) => w[0]).join("").toUpperCase();

/** Header + frame shared by the public pages (wizard, manage link, waitlist claim): one centred column, phone-first. */
export function PublicShell({ children, title, sub }: { children: ReactNode; title?: string; sub?: string }) {
  const { t, i18n } = useTranslation();
  const brand = useBrand();
  const name = brand ? tx(brand.name, i18n.language) : t("app.title");
  return (
    <main className="min-h-screen bg-ground">
      <div className="mx-auto w-full max-w-xl px-4 pb-6 pt-[max(12px,env(safe-area-inset-top))]">
        <header className="mb-3 flex items-center gap-3">
          {brand?.logo_url
            ? <img src={brand.logo_url} alt={name} className="h-10 w-10 flex-none rounded-full object-cover" />
            : <span className="grid h-10 w-10 flex-none place-items-center rounded-full text-[12px] font-bold text-white" style={{ background: "linear-gradient(145deg, var(--logo-a), var(--logo-b))" }}>{initials(name)}</span>}
          <div className="min-w-0"><b className="block truncate text-[15px] font-semibold leading-tight">{name}</b>{(title || sub) && <span className="block truncate text-xs text-muted">{[title, sub].filter(Boolean).join(" · ")}</span>}</div>
          <button type="button" className="ml-auto rounded-full border border-line-strong px-2.5 py-1 text-xs text-muted hover:text-ink" onClick={() => i18n.changeLanguage(i18n.language === "el" ? "en" : "el")}>{i18n.language === "el" ? "EN" : "EL"}</button>
        </header>
        {children}
      </div>
    </main>
  );
}

export function reasonText(t: (k: string, o?: Record<string, unknown>) => string, detail: string): string {
  try {
    const d = JSON.parse(detail);
    if (d && typeof d === "object" && "reason" in d) return t(`book.err.${d.reason}`, { defaultValue: t(`reason.${d.reason}`, { defaultValue: d.reason }) });
  } catch { /* plain string */ }
  return t(`book.err.${detail}`, { defaultValue: detail });
}
